export const BENEFITS_HEALTH = 'd3le1lc24f';
export const BENEFITS_PICKY = 'i7f8l9y94w';
export const REVIEWS_HERO = 'qxz0k46jak';
export const REVIEWS_BANNER = 'ao4qbtou21';
export const FOREVER_AD = 'z0dbb6aoyf';
export const MEET_THE_FOUNDERS = 'lyn2721eiy';
export const FOUNDERS_AND_VET_WELCOME = 'c97e26feok';
export const DOG_FOOD_NEEDS = 'z3rsi41vjg';
export const TRANSITIONS_HOW_IT_WORKS = 'etjc1ya0b0';
export const HINTS_HAPPY_EATING = '86l7z39vy9';
export const TRANSITION_DEMOS = {
  QUARTER_PACK: 'yqwzsbveye',
  HALF_PACK: 'lijazt2b9q',
  ONE_PACK: 'b8xc4lcspn',
  TWO_PACK: 'ynur1pctpc',
  THREE_PACK: 'hi7hgahojz',
};
export const FULL_PORTION_DEMOS = {
  QUARTER_PACK: 'yioshgl7tu',
  HALF_PACK: '56hfb4mvpv',
  ONE_PACK: 'c4o8gphtgs',
  TWO_PACK: 'xm1ryab3mq',
  THREE_PACK: 'zj9p0gka0t',
};
